import React from 'react';
import { CheckCircle } from 'react-feather';
import { PaymentPlan } from 'api/types/owner';
import { featureData } from './features';
import { Button, Card, CardContent, Typography } from 'ui-kit';

type Props = {
  plan: PaymentPlan;
};

export default function PlanFeatures({ plan }: Props) {
  const headerText = getFeaturesHeader(plan);
  const features = featureData[plan];
  return (
    <div className="PlanFeatures">
      <Typography variant="subtitle2" className="PlanFeaturesHeader">
        {headerText}
      </Typography>
      <Card className="PlanFeaturesCard">
        <CardContent>
          {features.map(({ text, highlight = false }, index) => (
            <div className="PlanFeaturesCardRow" key={index}>
              <CheckCircle size="20" />
              <Typography
                className="PlanFeaturesCardRowText"
                variant="body2"
                color={highlight ? 'primary' : 'textDark'}
              >
                {text}
              </Typography>
            </div>
          ))}
          <Button
            variant="contained"
            className="PlanFeaturesCardRow PlanFeaturesButton"
            onClick={() => {
              location.href = '#features';
            }}
          >
            See all features
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}

const getFeaturesHeader = (plan: PaymentPlan) => {
  switch (plan) {
    case PaymentPlan.Basic:
      return 'This includes:';
    case PaymentPlan.Pro:
      return 'Basic Features Plus:';
    case PaymentPlan.ProPlus:
      return 'Pro Features Plus:';
    case PaymentPlan.Enterprise:
      return 'Pro Plus Features Plus:';
  }
};
